// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-layer{position:fixed;top:0;inset-inline-start:0;z-index:9998;width:100%;height:100%}.loading-layer--white .loading-layer__backdrop{background:#fff}.loading-layer__backdrop{position:absolute;content:\" \";width:100%;height:100%;background:rgba(0,0,0,.5);z-index:0}.loading-layer__content{display:flex;justify-content:center;align-items:center;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
